import React from "react";
import Select from 'react-select'
import "./dropDownWhiteStyle.css";

const dropDownWhiteStyle = ({
    items,
    placeholder,
    onItemSelect,
    selected
}) => {
    return (
        <div className="row  hrow">
            <Select
                isClearable={false}
                isRtl="true"
                isSearchable={false}
                options={items}
                onChange={onItemSelect}
                placeholder={placeholder}
            />
        </div>
    );
};

export default dropDownWhiteStyle;

